export default {
    parts: [
        'loadingContainer',
        'loadingSpinner',
        'loadingText',
        'listContainer',
        'storeCard',
        'storeCardDefault',
        'storeCardSelected',
        'storeHeaderRow',
        'storeName',
        'storeAddress',
        'storeDistanceWrapper',
        'storeDistance',
        'storeAvailabilityRow',
        'storeAvailabilityDot',
        'storeAvailabilityText',
        'storeDivider',
        'noStoresContainer',
        'noStoresTitle',
        'noStoresDescription'
    ],
    baseStyle: {
        loadingContainer: {
            textAlign: 'center',
            py: 24
        },
        loadingSpinner: {
            size: 'lg',
            color: 'webTypo.textPrimary'
        },
        loadingText: {
            mt: 2
        },
        listContainer: {
            align: 'stretch',
            spacing: 0,
            py: 10
        },
        storeCard: {
            cursor: 'pointer',
            pt: 6,
        },
        storeCardDefault: {
            borderColor: 'black'
        },
        storeCardSelected: {
            borderColor: 'transparent',
            backgroundColor: 'warmWhite'
        },
        storeHeaderRow: {
            justify: 'space-between',
            align: 'start'
        },
        storeName: {
            textStyle: 'webH3'
        },
        storeAddress: {
            textStyle: 'bodySmRegular',
            mt: 2
        },
        storeDistanceWrapper: {
            spacing: 1,
            alignItems: 'normal'
        },
        storeDistance: {
            textStyle: 'bodyXsRegular',
            whiteSpace: 'nowrap'
        },
        storeAvailabilityRow: {
            mt: 4
        },
        storeAvailabilityDot: {
            w: '6px',
            h: '6px'
        },
        storeAvailabilityText: {
            textStyle: 'bodyXsRegular'
        },
        storeDivider: {
            mt: 3,
            borderColor: 'inherit'
        },
        noStoresContainer: {
            flexDirection: 'column',
            gap: 3,
            py: '26px',
        },
        noStoresTitle: {
            textStyle: 'labelXs'
        },
        noStoresDescription: {
            textStyle: 'bodyXsRegular'
        }
    }
}
